<hr>
<form [formGroup]="form" class="p-mb-3">
    <h4 *ngIf="!isAmount">{{nameMachine}} <span style="color: var(--boder-message-error)">(*)</span></h4>
    <div class="grid">
        <div class="col" > 
            <label for="description" class="labelForm" *ngIf="!isAmount">Descripción</label>
            <div class="p-inputgroup" *ngIf="!isAmount">
                <input type="text" pInputText placeholder="Nombre" description="description" min="0" maxlength="100"
                formControlName="description">
            </div>
        </div>
        <div class="col"> 
            <label for="inicialN" class="labelForm">Número inicial</label>
            <div class="p-inputgroup">
                <input id="float-input" type="number" placeholder="" pInputText formControlName="inicialN">
            </div>
        </div>
        <div class="col"> 
            <label for="finalN" class="labelForm">Número final</label>
            <div class="p-inputgroup">
                <input id="float-input" type="number" placeholder="" pInputText formControlName="finalN">
            </div>
        </div>
    </div>
</form>